import type { CardStatus, JobStatus, Verdict } from "../api/models";

const verdictLabels: Record<Verdict, string> = {
  correct: "Correct",
  wrong_pick: "Wrong pick",
  not_in_candidates: "Not in candidates",
  no_products: "No products",
  degraded: "Degraded",
  searched: "Web search",
  unscored: "Unscored",
};

export function formatVerdict(v: Verdict): { label: string; className: string } {
  return { label: verdictLabels[v], className: `badge badge-${v}` };
}

export const VERDICT_ORDER: Verdict[] = [
  "wrong_pick",
  "not_in_candidates",
  "no_products",
  "degraded",
  "searched",
  "correct",
  "unscored",
];

export function verdictRank(v: Verdict): number {
  return VERDICT_ORDER.indexOf(v);
}

export function formatStatus(s: CardStatus | JobStatus): { label: string; className: string } {
  const label = s === "NO_PRODUCT" ? "Not in catalog" : s.charAt(0) + s.slice(1).toLowerCase();
  return { label, className: `badge badge-${s.toLowerCase()}` };
}
